import { createPopper } from '@popperjs/core'
import { closest } from '@/utils/dom'
// import { useZIndex } from 'element-plus/es/hooks/use-z-index/index'
function useZIndex() {
  return {
    nextZIndex: function() {
      return 2100
    }
  }
}
// 渲染箭头
function renderArrow () {
  const arrow = document.createElement('div')
  arrow.className = 'popper__arrow'
  return arrow
}
// 渲染内容
function renderContent (value) {
  const { nextZIndex } = useZIndex()
  const content = document.createElement('div')
  content.className = 'el-tooltip__popper el-table-tooltip is-dark'
  content.innerHTML = value
  content.style.zIndex = String(nextZIndex())
  document.body.appendChild(content)
  return content
}

// 初始化tooltip
function initToolTip(el, binding) {
  let removePopperTime = null
  el.addEventListener('mouseover', () => {
    if (el.scrollWidth <= el.offsetWidth) {
      return
    }
    // 判断当前元素有没有未删除的Popper，有则阻止删除并且return
    if (removePopperTime) {
      clearTimeout(removePopperTime)
      removePopperTime = null
      return
    }
    // Popper显示的内容
    const value = binding.value || el.textContent
    if (!value) {
      return
    }
    // 创建Popper元素
    const content = renderContent(value)
    // 创建Popper小三角
    const arrow = renderArrow()
    content.appendChild(arrow)

    // 调用插件，渲染Popper
    createPopper(el, content, {
      strategy: 'absolute',
      placement: 'top',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 8]
          }
        },
        {
          name: 'arrow',
          options: {
            element: arrow,
            padding: 10
          }
        }
      ]
    })
    // 删除
    const removePopper = () => {
      removePopperTime = setTimeout(() => {
        try {
          content && document.body.removeChild(content)
          el.removeEventListener('mouseout', removePopper)
        } catch {}
        clearTimeout(removePopperTime)
        removePopperTime = null
      }, 300)
    }
    // 移入弹框后取消删除
    content.addEventListener('mouseover', () => {
      clearTimeout(removePopperTime)
      removePopperTime = null
    })
    // 元素移出
    el.addEventListener('mouseout', removePopper)
    // 弹框移出
    content.addEventListener('mouseout', removePopper)
  })
}

// overflowTooltip指令开始执行
async function insertToolTip(el, binding) {
  let vm, trList, trList2, tdIndex
  if (el.__vue__) {
    vm = el.__vue__
    await vm.$nextTick()
    const tableDiv = el.parentNode.parentNode
    trList = [...tableDiv.querySelectorAll('.el-table__body-wrapper table tbody tr.el-table__row')]
    trList2 = [...tableDiv.querySelectorAll('.el-table__fixed-body-wrapper table tbody tr.el-table__row')]
    tdIndex = [...el.parentNode.children].findIndex(v => el === v)
  } else {
    const td = closest(el, 'td.el-table__cell')
    const tr = td.parentNode
    tdIndex = [...tr.children].findIndex(v => v === td)
    trList = [...tr.parentNode.children]
    const tableDiv = closest(el, '.el-table')
    trList2 = [...tableDiv.querySelectorAll('.el-table__fixed-body-wrapper table tbody tr.el-table__row')]
    // console.log(td, tdIndex, tableDiv, trList)
    // debugger
  }
  // 处理每一行的tdIndex td
  function handleRowTooltip(row) {
    const td = row.querySelectorAll('td')[tdIndex]
    if (!td) return
    const el = td.querySelector('div')
    el.style.overflow = 'hidden'
    el.style.textOverflow = 'ellipsis'
    el.style.whiteSpace = 'nowrap'
    initToolTip(el, binding)
  }
  trList?.forEach(handleRowTooltip)
  trList2?.forEach(handleRowTooltip)
}

export default (Vue) => {
  Vue.directive('overflowTooltip', {
    // bind: function (el, binding) {},
    update: insertToolTip,
    inserted: insertToolTip,
  })

}
